// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__37RT3","upload":"Small_upload__d7C9h","imageWrap":"Small_imageWrap__10k9C","removeBtn":"Small_removeBtn__23irN"};